export const dashboardPageSx = {
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  color: "text.primary",
  bgcolor: "background.default",
  overflowX: "hidden",
} as const;

export const dashboardPagePaddingSx = {
  px: { xs: 1.3, sm: 1.7 },
  py: { xs: 1.3, sm: 1.7 },
} as const;

export const dashboardPanelSx = {
  width: "100%",
  boxSizing: "border-box",
  p: { xs: 0.85, sm: 1.7 },
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 0,
  bgcolor: "background.paper",
} as const;

export const dashboardPanelNoPaddingSx = {
  width: "100%",
  boxSizing: "border-box",
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 0,
  bgcolor: "background.paper",
} as const;

export const dashboardInsetPanelSx = {
  width: "100%",
  boxSizing: "border-box",
  p: { xs: 0.85, sm: 1.3 },
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 0,
  bgcolor: "background.paper",
} as const;

export const dashboardCardSx = {
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 1,
  bgcolor: "background.paper",
  boxShadow: "none",
  boxSizing: "border-box",
} as const;

export const dashboardSectionTitleSx = {
  fontWeight: 700,
  color: "text.primary",
  lineHeight: 1.25,
} as const;
